// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React, {useEffect, useRef} from 'react'
// import ApexCharts, {ApexOptions} from 'apexcharts'
// import {KTSVG} from '../../../helpers'
// import {Dropdown1} from '../../content/dropdown/Dropdown1'
// import {getCSS, getCSSVariableValue} from '../../../assets/ts/_utils'
// import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'

// type Props = {
//   className: string
// }

// const ChartsWidget1: React.FC<Props> = ({className}) => {
//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const {mode} = useThemeMode()

//   useEffect(() => {
//     const chart = refreshChart()

//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
//   }, [chartRef, mode])

//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const height = parseInt(getCSS(chartRef.current, 'height'))

//     const chart = new ApexCharts(chartRef.current, getChartOptions(height))
//     if (chart) {
//       chart.render()
//     }

//     return chart
//   }

//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Header */}
//       <div className='card-header border-0 pt-5'>
//         {/* begin::Title */}
//         <h3 className='card-title align-items-start flex-column'>
//           <span className='card-label fw-bold fs-3 mb-1'>Demo Recent Statistics</span>

//           <span className='text-muted fw-semibold fs-7'>More than 400 new members</span>
//         </h3>
//         {/* end::Title */}

//         {/* begin::Toolbar */}
//         <div className='card-toolbar'>
//           {/* begin::Menu */}
//           <button
//             type='button'
//             className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
//             data-kt-menu-trigger='click'
//             data-kt-menu-placement='bottom-end'
//             data-kt-menu-flip='top-end'
//           >
//             <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
//           </button>
//           <Dropdown1 />
//           {/* end::Menu */}
//         </div>
//         {/* end::Toolbar */}
//       </div>
//       {/* end::Header */}

//       {/* begin::Body */}
//       <div className='card-body'>
//         {/* begin::Chart */}
//         <div ref={chartRef} id='kt_charts_widget_1_chart' style={{height: '350px'}} />
//         {/* end::Chart */}
//       </div>
//       {/* end::Body */}
//     </div>
//   )
// }

// export {ChartsWidget1}

// function getChartOptions(height: number): ApexOptions {
//   const labelColor = getCSSVariableValue('--kt-gray-500')
//   const borderColor = getCSSVariableValue('--kt-gray-200')
//   const baseColor = getCSSVariableValue('--kt-primary')
//   const secondaryColor = getCSSVariableValue('--kt-gray-300')

//   return {
//     series: [
//       {
//         name: 'Net Profit',
//         data: [44, 55, 57, 56, 61, 58],
//       },
//       {
//         name: 'Revenue',
//         data: [76, 85, 101, 98, 87, 105],
//       },
//     ],
//     chart: {
//       fontFamily: 'inherit',
//       type: 'bar',
//       height: height,
//       toolbar: {
//         show: false,
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: false,
//         columnWidth: '30%',
//         borderRadius: 5,
//       },
//     },
//     legend: {
//       show: false,
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     stroke: {
//       show: true,
//       width: 2,
//       colors: ['transparent'],
//     },
//     xaxis: {
//       categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//       labels: {
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//     },
//     yaxis: {
//       labels: {
//         style: {
//           colors: labelColor,
//           fontSize: '12px',
//         },
//       },
//     },
//     fill: {
//       opacity: 1,
//     },
//     states: {
//       normal: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       hover: {
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//       active: {
//         allowMultipleDataPointsSelection: false,
//         filter: {
//           type: 'none',
//           value: 0,
//         },
//       },
//     },
//     tooltip: {
//       style: {
//         fontSize: '12px',
//       },
//       y: {
//         formatter: function (val) {
//           return '$' + val + ' thousands'
//         },
//       },
//     },
//     colors: [baseColor, secondaryColor],
//     grid: {
//       borderColor: borderColor,
//       strokeDashArray: 4,
//       yaxis: {
//         lines: {
//           show: true,
//         },
//       },
//     },
//   }
// }


/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect,useState, useRef } from 'react'
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment'
// import { getCSSVariableValue } from '../../../../assets/ts/_utils'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
}

const ChartsWidget1: FC<Props> = ({
  className,
  chartSize = 70,
  chartLine = 11,
  chartRotate = 145,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  let [selectedDate, setSelectedDate] = useState<string>('');
  let [selectedData, setSelectedData] = useState<any>([]);
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(event.target.value);
    console.log("dates",selectedDate);
     // Update the selectedDate state
  };

  const EmployeeData = () => {
  
    // let selectedDate = new Date(); // Assuming you have a selectedDate variable defined
  console.log("I'm here ");
  // if (!selectedDate) {
  //   // If selectedDate is empty, set it to the current date
  //   selectedDate = new Date();
  // }
  
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
  
    const raw = JSON.stringify({
      punchDate:selectedDate
      ? moment(selectedDate).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD"),
    });

    console.log(raw,"raw");
    
  
    const requestOptions: RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
  
    fetch(`https://crm.romsons.com:8080/EmplyeeInfoWeb`, requestOptions)
      .then(response => response.text())
      .then(result => {
        let arr = JSON.parse(result)
        selectedData = arr.data;
        setSelectedData(selectedData);
        // console.log(selectedData,"result");
      })
      .catch(error => console.log('error', error));
  };

  useEffect(()=>{
    EmployeeData();
  },[])

  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <div className='d-flex align-items-center'>
            <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>Employee</span>
          </div>
          <span className='text-gray-400 pt-1 fw-semibold fs-6'>Employee Information</span>
        </div>
      </div>

      <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
       


      
        <div className="overflow-x-auto">
        <div className='d-flex flex-center me-5 pt-2'>
         
        <input
  type="date"
  value={selectedDate}
  onChange={handleDateChange}
  className='form-control form-control-solid w-250px ps-14 fs-7'
/>

<button
  onClick={EmployeeData}
  className='btn btn-primary'
>
  Show Data
</button>

       </div>
       <br/>
       <br/>
      <table className="min-w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Employee</th>
            <th className="border border-gray-300 px-4 py-2">MSD</th>
            <th className="border border-gray-300 px-4 py-2">RETAIL</th>
            <th className="border border-gray-300 px-4 py-2">KAD</th>
            <th className="border border-gray-300 px-4 py-2">OPS</th>
            <th className="border border-gray-300 px-4 py-2">GTD</th>
            <th className="border border-gray-300 px-4 py-2">GOVT</th>
            <th className="border border-gray-300 px-4 py-2">Total</th>
          </tr>
        </thead>
        <tbody>
        
       
        <tr>
                <td className="border border-gray-300 px-4 py-2">Present</td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.MSD_Trans !== null ? selectedData[2]?.MSD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.Retail_Trans !== null ? selectedData[2]?.Retail_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.KAD_Trans !== null ? selectedData[2]?.KAD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.OPS_Trans !== null ? selectedData[2]?.OPS_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.GTD_Trans !== null ? selectedData[2]?.GTD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.GOVT_Trans !== null ? selectedData[2]?.GOVT_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.Total_Trans !== null ? selectedData[2]?.Total_Trans : 'null'}
                </td>
              </tr>
         
              <tr>
                <td className="border border-gray-300 px-4 py-2">Leave</td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.MSD_Trans !== null ? selectedData[1]?.MSD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.Retail_Trans !== null ? selectedData[1]?.Retail_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.KAD_Trans !== null ? selectedData[1]?.KAD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.OPS_Trans !== null ? selectedData[1]?.OPS_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.GTD_Trans !== null ? selectedData[1]?.GTD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.GOVT_Trans !== null ? selectedData[1]?.GOVT_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.Total_Trans !== null ? selectedData[1]?.Total_Trans : 'null'}
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Abset</td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.MSD_Trans !== null ? selectedData[0]?.MSD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.Retail_Trans !== null ? selectedData[0]?.Retail_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.KAD_Trans !== null ? selectedData[0]?.KAD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.OPS_Trans !== null ? selectedData[0]?.OPS_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.GTD_Trans !== null ? selectedData[0]?.GTD_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.GOVT_Trans !== null ? selectedData[0]?.GOVT_Trans : 'null'}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {selectedData[2]?.Total_Trans !== null ? selectedData[0]?.Total_Trans : 'null'}
                </td>
              </tr>

        </tbody>
      </table>
    </div>
      </div>
    </div>
  )
}



export { ChartsWidget1 }

